// クリップボード（貼り付け）から画像ファイルを取り出すユーティリティ。
// スクリーンショット等の貼り付け画像は File 名が空になることがあるため、フォールバック名を補う。

// 名前を持たない貼り付け画像に付けるファイル名のベース
const PASTED_IMAGE_FALLBACK_BASENAME = 'pasted-image';

/**
 * クリップボードから image/* の File を取り出す。
 * 名前を持たない File（スクリーンショット等）にはフォールバック名を付与する。
 */
export function extractPastedImageFiles(clipboardData: DataTransfer): File[] {
  const files: File[] = [];
  const items = clipboardData.items;
  // DataTransferItemList はイテレータを持たないため添字で走査する
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    if (item.kind !== 'file' || !item.type.startsWith('image/')) continue;
    const file = item.getAsFile();
    if (!file) continue;
    files.push(file.name ? file : renameToFallback(file, files.length));
  }
  return files;
}

// 拡張子を MIME から推定してフォールバック名を作る（同一貼り付けで複数枚のときは連番を付ける）
function renameToFallback(file: File, index: number): File {
  const extension = file.type.split('/')[1] || 'png';
  const suffix = index === 0 ? '' : `-${index + 1}`;
  const name = `${PASTED_IMAGE_FALLBACK_BASENAME}${suffix}.${extension}`;
  return new File([file], name, { type: file.type });
}
